import { useTranslation } from 'next-i18next/pages';
import { DefaultSeo } from 'next-seo';

import {
  SITE_DESCRIPTION,
  SITE_LOCALE,
  SITE_TITLE,
  SITE_TITLE_TEMPLATE,
  SITE_URL,
  THEME_COLOR,
} from '../site-metadata';

const MetaInfo = () => {
  const { t } = useTranslation();

  const defaultTitle = t(SITE_TITLE);
  const descText = t(SITE_DESCRIPTION);

  return (
    <DefaultSeo
      title={defaultTitle}
      titleTemplate={SITE_TITLE_TEMPLATE}
      defaultTitle={defaultTitle}
      description={descText}
      openGraph={{
        type: 'website',
        locale: SITE_LOCALE,
        url: SITE_URL,
        site_name: SITE_TITLE,
      }}
      twitter={{
        site: '@letshighlight',
        cardType: 'summary_large_image',
      }}
      languageAlternates={[{ hrefLang: 'en', href: `${SITE_URL}en` }]}
      additionalMetaTags={[
        // PWA
        {
          name: 'application-name',
          content: descText,
        },
        { name: 'theme-color', content: THEME_COLOR },

        {
          name: 'viewport',
          content: 'minimum-scale=1, initial-scale=1, width=device-width, viewport-fit=cover',
        },
        {
          name: 'format-detection',
          content: 'telephone=no',
        },
        {
          name: 'mobile-web-app-capable',
          content: 'yes',
        },

        // apple
        {
          name: 'apple-mobile-web-app-capable',
          content: 'yes',
        },
        {
          name: 'apple-mobile-web-app-status-bar-style',
          content: 'default',
        },
        {
          name: 'apple-mobile-web-app-title',
          content: descText,
        },

        // ms
        // {
        //   name: 'msapplication-config',
        //   content: '/icons/browserconfig.xml',
        // },
        {
          name: 'msapplication-TileColor',
          content: THEME_COLOR,
        },
        {
          name: 'msapplication-tap-highlight',
          content: 'no',
        },
      ]}
    />
  );
};

export default MetaInfo;
